import React from "react";

import * as VerticalSC from "./../../../../Previews/PostEditors/post-editor-vertical/PostEditorVertical.styled";

import logger from "../../../../../../utils/LoggerFrontend";
import { ButtonOutlinedAnchor } from "../../../../Previews/Components/Buttons";
import PrintCampaignCreateChannelDataEditor from "../../print-channel-editor/PrintCampaignCreateChannelDataEditor";
import PrintCampaignCreateTeaserEditor from "../../print-campaign-create-teaser-editor/PrintCampaignCreateTeaserEditor";

import { channelsByShortName } from "../../../../../../data/app__channels";

import {
  PostEditorFacebookWrapper,
  MobileTop,
  MobileSide,
  MobileBottom,
  FacebookEditorWrapper,
  FacebookEditor,
  Header,
  EditorWrapper,
  PhotoEditorWrapper,
  FacebookInfoLogo,
  FooterWrapper,
  FooterTextSections,
  FACEBOOK_IMAGE_SIZE_SPEC,
  teaserTextStyle,
  displayLinkStyle,
  subHeadlineStyle,
  titleStyle
} from "./PrintPostEditorFacebook.styled";

import PageHeader from "./page-header/PageHeader";
import PrintTemplateEditor from "../../print-campaign-template-editor/PrintTemplateEditor";
import { VERTICAL_TEMPLATE_IDS } from "../../../../Previews/constants";

import {
  IMAGE_TEMPLATES_INFO,
  VIDEO_TEMPLATES_INFO
} from "@talentbait/remotion-templates-talentbait";
import { useTranslation } from "react-i18next";

const allTemplatesInfo = { ...IMAGE_TEMPLATES_INFO, ...VIDEO_TEMPLATES_INFO };

const PrintPostEditorFacebook = ({
  postData,
  channelData,
  channel,
  updatePost,
  updateChannelData,
  mobile,
  adsetId,
  editable,
  loading,
  selectedCreativeIndexToEdit,
  imageDimensions,
  hasAts,
  mediaAssetsProps,
  mediaAssets,
  shouldUseLongImage
}) => {
  logger.debug("PrintPostEditorFacebook:render", "render:", {
    postData,
    channelData,
    mobile,
    editable,
    adsetId,
    imageDimensions,
    hasAts,
    channel,
    mediaAssetsProps,
    mediaAssets,
    shouldUseLongImage
  });
  const { t } = useTranslation();
  const { inputProps, templateId } = mediaAssetsProps[selectedCreativeIndexToEdit] || {};

  const template = allTemplatesInfo[templateId];

  const multiTemplatesOrientation =
    template?.orientation === "multi" && inputProps?.orientation === "vertical";

  const verticalTemplate =
    VERTICAL_TEMPLATE_IDS.includes(template?.id) || multiTemplatesOrientation;

  const templateSC = verticalTemplate
    ? VerticalSC.VERTICAL_IMAGE_SPEC["facebook"][mobile ? "mobile" : "web"]["print"]
    : FACEBOOK_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"];

  const minAspect = verticalTemplate
    ? templateSC.minAspect
    : channelsByShortName.facebook.minAspect;

  const maxAspect = verticalTemplate
    ? templateSC.maxAspect
    : channelsByShortName.facebook.maxAspect;

  const templatePreviewSizes = {
    minHeight: templateSC.minHeight,
    maxHeight: templateSC.maxHeight,
    width: templateSC.pictureWidth,
    minAspect: minAspect,
    maxAspect: maxAspect
  };

  return (
    <PostEditorFacebookWrapper mobile={mobile} verticalTemplate={verticalTemplate}>
      {mobile && <MobileTop src="/images/mobile-top.png" alt="" />}
      <div style={{ display: "flex" }}>
        {mobile && <MobileSide src="/images/mobile-left.png" alt="" />}
        <FacebookEditorWrapper mobile={mobile}>
          <FacebookEditor mobile={mobile}>
            <Header>
              <PageHeader
                loading={loading}
                pageLogo={channelData?.pageLogo}
                pageName={channelData?.pageName}
                pageId={channelData?.pageId}
                sponsoredLogo
              />
            </Header>
            <EditorWrapper>
              <PrintCampaignCreateTeaserEditor
                channel="facebook"
                updatePost={updatePost}
                teaserText={postData.teaserText}
                editable={editable}
                teaserTextStyle={teaserTextStyle}
                smallButtons={mobile}
                isAutoGenerated={postData?.isAutoGenerated}
                autoGeneratedText={postData?.autoGeneratedText}
                isEdited={postData?.editedStates?.teaserText}
              />
            </EditorWrapper>
            <PhotoEditorWrapper>
              <PrintTemplateEditor
                selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
                mediaAssets={mediaAssets}
                mediaAssetsProps={mediaAssetsProps}
                templateType="image"
                creatives={postData.creatives}
                creativeAssets={postData.creativeAssets}
                logos={postData.logos || postData.creatives.map(() => "")}
                templatePreviewSizes={templatePreviewSizes}
                channel={channel}
              />

              <FacebookInfoLogo src="/images/facebook_info_icon.svg" alt="" />
            </PhotoEditorWrapper>
            <FooterWrapper>
              <FooterTextSections>
                <PrintCampaignCreateChannelDataEditor
                  updateChannelData={updateChannelData}
                  value={channelData.displayLink}
                  dataKey="displayLink"
                  textStyle={displayLinkStyle}
                  limit={channelsByShortName.facebook.limits.displayLink}
                  label={t("Displayed link")}
                  bannedCharaters={["!", "?"]}
                  editable={editable}
                  urlValue={channelData.url}
                />

                <PrintCampaignCreateChannelDataEditor
                  updateChannelData={updateChannelData}
                  value={channelData.title}
                  dataKey="title"
                  textStyle={titleStyle}
                  limit={channelsByShortName.facebook.limits.title}
                  label={t("Job Title")}
                  editable={editable}
                />

                <PrintCampaignCreateChannelDataEditor
                  updateChannelData={updateChannelData}
                  value={channelData.subHeadline}
                  dataKey="subHeadline"
                  textStyle={subHeadlineStyle}
                  limit={channelsByShortName.facebook.limits.subHeadline}
                  label={t("Subtitle")}
                  editable={editable}
                />
              </FooterTextSections>
              <ButtonOutlinedAnchor target="_blank" href={channelData?.url || "#"}>
                {t("Read more")}
              </ButtonOutlinedAnchor>
            </FooterWrapper>
          </FacebookEditor>
        </FacebookEditorWrapper>
        {mobile && <MobileSide src="/images/mobile-right.png" alt="" />}
      </div>
      {mobile && <MobileBottom src="/images/mobile-bottom.png" alt="" />}
    </PostEditorFacebookWrapper>
  );
};

export default PrintPostEditorFacebook;
